import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListingMagasin } from '@components/listing-magasin/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/button';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { StoreWithUuid } from '@shared/models';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { LogsService } from '@shared/services/logs';
import { getStoreStatus } from '@shared/utils';
import { take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-listing-magasin',
  templateUrl: './listing-magasin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, SvgComponent, ButtonComponent, TranslatePipe],
})
export class ListingMagasinComponent extends AbstractDynamicComponent<ListingMagasin> implements OnInit {
  protected readonly stores = signal<StoreWithUuid[] | null>(null);
  protected readonly storeDisplayData = computed(() =>
    (this.stores() ?? []).map((store) => ({
      operationalStatus: store.operationalStatus,
      storeStatus: store.weeklyOpeningHours ? getStoreStatus(store.weeklyOpeningHours) : null,
    }))
  );
  private readonly elasticSearchService = inject(ElasticSearchService);
  private readonly logs = inject(LogsService);

  ngOnInit() {
    this.elasticSearchService
      .getStoresByArea(this.data.type, this.data.area)
      .pipe(
        take(1),
        tap((stores) => this.stores.set(stores))
      )
      .subscribe({ error: (err) => this.logs.error('ListingMagasinComponent', 'getStoresByArea failed', err) });
  }
}
